/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { selectCurrentSalonCurrency, selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import ReportTableContainer from 'reports/Common/ReportTable';
import { calculateTotalsOnProductSalesData, calculateTotalsOnServiceSalesData } from 'reports/sales.bl';
import { getRevenuSummary } from 'reports/utils';

class RevenueByStylistTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // this map is used to map the names of the stylists to the total price and discount of the products they sold
    // example {"Name":{totalProductPrice: number, totalDiscountPrice: number}}
    const nameServicesTotalPriceMap = {};
    const visits = {};
    const noShows = {};
    this.props.data.forEach((stylist) => {
      nameServicesTotalPriceMap[stylist.name] = calculateTotalsOnServiceSalesData(stylist.services);
    });
    const nameProductsTotalPriceMap = {};
    this.props.data.forEach((stylist) => {
      nameProductsTotalPriceMap[stylist.name] = calculateTotalsOnProductSalesData(stylist.products);
      visits[stylist.name] = stylist.visits;
      noShows[stylist.name] = stylist.revenue_from_no_shows;
    });

    const currencyAbbr = this.props.currency;

    return (
      <div id="revenue-summary">
        <ReportTableContainer
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          title="Revenue Summary"
          data={{
            rows: getRevenuSummary(
              nameServicesTotalPriceMap,
              nameProductsTotalPriceMap,
              noShows,
              visits,
              this.props.visits,
              currencyAbbr,
            ),
          }}
        >
          <NavLink
            to={`/salon/${this.props.salonId}/communications/marketing`}
            onClick={alwaysNoop}
            className="btn btn-violet btn-report in-revenue-tbl"
          >
            Get more bookings!
          </NavLink>
        </ReportTableContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  salonId: selectCurrentSalonId(state),
  currency: selectCurrentSalonCurrency(state),
});

const RevenueByStylistTableHoc = connect(mapStateToProps)(RevenueByStylistTable);

export default RevenueByStylistTableHoc;
